import { B as BiButton$1, d as defineCustomElement$1 } from './p-5313e3e6.js';

const BiButton = BiButton$1;
const defineCustomElement = defineCustomElement$1;

export { BiButton, defineCustomElement };
